import React from 'react';

/** Truncates overflowing cell text. Tooltip is handled by TableCellTooltip. */
export default function CellText({ text, className = '', style }) {
  const value = text == null || text === '' ? '' : String(text);

  return (
    <span className={`app-cell-ellipsis ${className}`.trim()} style={style}>
      {value}
    </span>
  );
}
